// shared/filters/state.js
// To be used as a common filter state for multiple reports or del lists

/**Used to make add specific parameters to the filters state based on what main state file they are imported to.
 * @params status: String, empty string, drafts, submits, approved
 * @params delStartDate: Date, null
 * @params delEndDate: Date, null
 * @params submitStartDate: Date, null
 * @params submitEndDate: Date, null
 * @params approvalStartDate: Date, null
 * @params approvalEndDate: Date, null
 * @params projectNumber: String, empty string
 * @params projectLabel: String, empty string
 * @params phase: String, empty string
 * @params phaseLabel: String, empty string
 * @params projectManager: String, empty string
 * @params projectManagerName: String, empty string
 * @params invoiceManager: String, empty string
 * @params invoiceManagerName: String, empty string
 * @params createdBy: String, empty string or employee id
 * @params approvedBy: String, empty string or employee id
 * @params createdStartDate: Date, null
 * @params createdEndDate: Date, null
 */
export const filtersInitialState = ({
  status = "",
  delStartDate = null,
  delEndDate = null,
  submitStartDate = null,
  submitEndDate = null,
  approvalStartDate = null,
  approvalEndDate = null,
  projectNumber = "",
  projectLabel = "",
  phase = "",
  phaseLabel = "",
  projectManager = "",
  projectManagerName = "",
  invoiceManager = "",
  invoiceManagerName = "",
  createdBy = "",
  createdByName = "",
  approvedBy = "",
  approvedByName = "",
  createdStartDate = null,
  createdEndDate = null,
  delStatus = "",
  delStatusLabel = "",
  // Safety form specific filters
  incidentDateStart = null,
  incidentDateEnd = null,
  auditDateStart = null,
  auditDateEnd = null,
  reportedTo = "",
  reportedToName = "",
  reportedBy = "",
  reportedByName = "",
  supervisor = "",
  supervisorName = "",
} = {}) => {
  return {
    status,
    delStartDate,
    delEndDate,
    submitStartDate,
    submitEndDate,
    approvalStartDate,
    approvalEndDate,
    projectNumber,
    projectLabel,
    phase,
    phaseLabel,
    projectManager,
    projectManagerName,
    invoiceManager,
    invoiceManagerName,
    createdBy,
    createdByName,
    approvedBy,
    approvedByName,
    createdStartDate,
    createdEndDate,
    delStatus,
    delStatusLabel,
    // Safety form specific filters
    incidentDateStart,
    incidentDateEnd,
    auditDateStart,
    auditDateEnd,
    reportedTo,
    reportedToName,
    reportedBy,
    reportedByName,
    supervisor,
    supervisorName,
  };
};
